import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTPMethod, InterceptorEndpoints } from '@core/const';

@Injectable({ providedIn: 'root' })
export class InterceptorEndpointService {
  requestIsIntercept(request: HttpRequest<any>, endpoints: InterceptorEndpoints[]): boolean {
    return endpoints.some(
      (item: InterceptorEndpoints) =>
        request.url.includes(item.url) && item.methods.some((method: HTTPMethod) => method === request.method),
    );
  }
}
